import { styled } from "@mui/system";

const Badge = styled("div")((style) => ({
  color: "black",
  borderRadius: "8px",
  width: "100px",
  height: "20px",
  padding: "2px",
  border: "2px solid #FFB74D",
  backgroundColor: "#FFDCA9",
  fontSize: "12px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  ...style,
}));

export const FeaturedBadge = (style) => (
  <Badge style={style}>⭐ Featured</Badge>
);
